import api from './api';

export const adminApi = {
  // Dashboard
  getDashboard: () => api.get('/admin/dashboard'),

  // Businesses
  getBusinesses: (params) => api.get('/admin/businesses', { params }),
  getBusinessDetail: (id) => api.get(`/admin/businesses/${id}`),
  extendTrial: (id, data) => api.post(`/admin/businesses/${id}/extend-trial`, data),
  toggleBusinessActive: (id) => api.post(`/admin/businesses/${id}/toggle-active`),
  toggleFoundingMember: (id) => api.post(`/admin/businesses/${id}/toggle-founding-member`),

  // Financials
  getFinancials: (params) => api.get('/admin/financials', { params }),
  getScheduleC: (year) => api.get(`/admin/financials/schedule-c/${year}`),

  // Expenses
  getExpenses: (params) => api.get('/admin/expenses', { params }),
  getExpenseCategories: () => api.get('/admin/expenses/categories'),
  createExpense: (data) => api.post('/admin/expenses', data),
  updateExpense: (id, data) => api.put(`/admin/expenses/${id}`, data),
  deleteExpense: (id) => api.delete(`/admin/expenses/${id}`),
  getBusinessUsers: (businessId) => api.get(`/admin/businesses/${businessId}/users`),
  resetUserMfa: (userId) => api.post(`/admin/users/${userId}/reset-mfa`),

  // Get platform revenue (application fees from payment processing)
getPlatformRevenue: (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  return api.get(`/admin/revenue?${params.toString()}`);
},

};

export default adminApi;